const PenEditIcon = ({ size = 20, className = "" }) => {
  return (
    <svg
      className={`inline-block cursor-pointer ${className}`}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 16.6666H17.5M2.50002 16.6666H3.89547C4.30312 16.6666 4.50694 16.6666 4.69876 16.6206C4.86882 16.5798 5.03139 16.5124 5.18051 16.421C5.34871 16.318 5.49283 16.1738 5.78109 15.8856L16.25 5.41663C16.9404 4.72628 16.9404 3.60699 16.25 2.91663C15.5597 2.22628 14.4404 2.22628 13.75 2.91663L3.28107 13.3856C2.99281 13.6738 2.84869 13.818 2.74562 13.9862C2.65423 14.1353 2.58689 14.2979 2.54607 14.4679C2.50002 14.6597 2.50002 14.8636 2.50002 15.2712V16.6666Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PenEditIcon;
